var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.829,
    height: 30.821,
    viewBox: "0 0 30.829 30.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823",
    transform: "translate(0.527 0.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32242",
    "data-name": "Path 32242",
    d: "M26.047,5.017c.058-.908.112-1.735.162-2.563a1.1,1.1,0,0,1,.84-1.027A1.04,1.04,0,0,1,28.3,2.538q-.171,2.785-.347,5.569a1.081,1.081,0,0,1-1.084.955q-2.467-.008-4.933-.022A1.041,1.041,0,0,1,20.813,7.8a1.055,1.055,0,0,1,1.1-.855c.931,0,1.861,0,2.792,0h.207a10.363,10.363,0,0,0-1.5-1.6A12.687,12.687,0,0,0,16.183,2.18,12.805,12.805,0,0,0,8.93,26.253a12.99,12.99,0,0,0,6.747,1.46,12.85,12.85,0,0,0,11.632-9.594,13.165,13.165,0,0,0,.4-3.173,1.045,1.045,0,0,1,2.007-.434,1.068,1.068,0,0,1,.083.474,14.623,14.623,0,0,1-5.444,11.428,14.425,14.425,0,0,1-10.1,3.384A14.879,14.879,0,0,1,10.889.6c5.748-1.563,10.764-.05,14.95,4.191.052.053.1.108.208.223",
    transform: "translate(0 -0.001)",
    stroke: "#f9f8f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32243",
    "data-name": "Path 32243",
    d: "M159.713,84.487q0-1.687,0-3.374a1.042,1.042,0,1,1,2.078,0c0,2.011,0,4.023,0,6.034a.52.52,0,0,0,.243.476c1.569,1.164,3.129,2.341,4.693,3.512a1.294,1.294,0,0,1,.585.745,1.039,1.039,0,0,1-.428,1.108,1.025,1.025,0,0,1-1.238-.045c-.7-.511-1.384-1.034-2.075-1.552-1.1-.823-2.19-1.652-3.294-2.466a1.264,1.264,0,0,1-.567-1.125c.022-1.1.007-2.206.007-3.309",
    transform: "translate(-145.845 -73.045)",
    stroke: "#f9f8f8",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c3590c752451587ab754a3bad7ec3bc0.svg";
export { ForwardRef as ReactComponent };